import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/es5/locale/es";
import "@mdi/font/css/materialdesignicons.css";
Vue.use(Vuetify);

const vuetify = new Vuetify({
  breakpoint: {
    mobileBreakpoint: "sm", // This is equivalent to a value of 960
  },
  theme: {
    themes: {
      light: {
        primary: "#7C2629",
        secondary: "#D3BC8D",
        accent: "#B05954",
        error: "#BC331E",
        warning: "#75787B",
        info: "#4d6572",
        success: "#2E7D32",
        "primary-100": "#F8E0D5",
        "primary-200": "#F1BEAE",
        "primary-300": "#D78A7D",
        "primary-400": "#B05954",
        "primary-500": "#7C2629",
        "primary-600": "#6A1B25",
        "primary-700": "#591321",
        "primary-800": "#470C1E",
        "primary-900": "#3B071B",
        "success-100": "#FCF9EC",
        "success-200": "#FAF3D9",
        "success-300": "#F1E5C1",
        "success-400": "#E4D3AB",
        "success-500": "#D3BC8D",
        "success-600": "#B59967",
        "success-700": "#977747",
        "success-800": "#7A592C",
        "success-900": "#65421B",
        "info-100": "#E7F6F7",
        "info-200": "#D1EBF0",
        "info-300": "#ABCBD4",
        "info-400": "#809EAA",
        "info-500": "#4d6572",
        "info-600": "#385062",
        "info-700": "#263D52",
        "info-800": "#182B42",
        "info-900": "#0E1E36",
        "warning-100": "#F5F7F8",
        "warning-200": "#EDF0F1",
        "warning-300": "#D1D4D7",
        "warning-400": "#A9ACAF",
        "warning-500": "#75787B",
        "warning-600": "#555E69",
        "warning-700": "#3A4658",
        "warning-800": "#253147",
        "warning-900": "#16213B",
        "danger-100": "#FBE4D1",
        "danger-200": "#F8C3A4",
        "danger-300": "#EA9674",
        "danger-400": "#D66C4F",
        "danger-500": "#BC331E",
        "danger-600": "#A11D15",
        "danger-700": "#870F12",
        "danger-800": "#6D0913",
        "danger-900": "#5A0515",
      },
    },
  },
  icons: {
    iconfont: "mdi" || "fa" || 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  lang: {
    locales: { es },
    current: "es",
  },
});
export default vuetify;
